import React, { useEffect, useRef } from 'react';
import './Sigiriya.css';
import hikkaduwa1 from '../../img/webp/hikkaduwa1.webp'; 
import hikkaduwa2 from '../../img/webp/hikkaduwa2.webp'; 
import hikkaduwa3 from '../../img/webp/hikkaduwa3.webp'; 
import hikkaduwa4 from '../../img/webp/hikkaduwa4.webp';
import DestinationSuggestions from '../../components/DestinationSuggestions';
import { getRandomSuggestions } from '../../data/destinationsData';
import SearchBar from '../../components/SearchBar';

const Hikkaduwa: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="destination-page">
      <SearchBar contentRef={contentRef} placeholder="Search Hikkaduwa information..." />
      
      <div ref={contentRef}>
      {/* Hero Section */}
      <section className="dest-hero">
        <img src={hikkaduwa1} alt="Hikkaduwa" />
        <div className="dest-badge">Hikkaduwa</div>
      </section>

      {/* Main Content Section */}
      <section className="dest-content">
        <div className="dest-container">
          <div className="dest-main-section">
            <div className="dest-left">
              <img src={hikkaduwa2} alt="Hikkaduwa Beach" />
            </div>
            <div className="dest-right">
              <h1 className="dest-title">Discover Hikkaduwa</h1>
              <p className="dest-description">
                A lively beach town famous for coral reefs, snorkeling, and vibrant nightlife.
              </p>
              
              <ul className="dest-features">
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Safe and reliable coastal travel arrangements
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Flexible beach and activity schedules
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.667 5L7.5 14.167 3.333 10" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Fun-filled and relaxing travel experience
                </li>
              </ul>

              <div className="dest-meta">
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="7" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="17" cy="17" r="2" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>Land Trip</span>
                </div>
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                    <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                  <span>2 Days</span>
                </div>
                <div className="dest-meta-item">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>Beach & Leisure</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="dest-bottom-section">
            <div className="dest-bottom-left">
              <p className="dest-bottom-text">
                Hikkaduwa is one of Sri Lanka's most popular beach destinations, well known for its colorful coral reefs and clear waters. It offers excellent opportunities for snorkeling, scuba diving, and glass-bottom boat rides, allowing visitors to explore marine life up close.
              </p>
              <p className="dest-bottom-text">
                In addition to water activities, Hikkaduwa is famous for its beachside restaurants, music, and nightlife. The combination of adventure, relaxation, and entertainment makes it an ideal destination for young travelers and beach lovers.
              </p>
            </div>
            <div className="dest-bottom-right">
              <img src={hikkaduwa3} alt="Hikkaduwa Marine Life" />
            </div>
          </div>

          {/* Ceylon D Tour Section */}
          <div className="dest-main-section" style={{ marginTop: '4rem' }}>
            <div className="dest-left">
              <img src={hikkaduwa4} alt="Ceylon D Tour Hikkaduwa experience" />
            </div>
            <div className="dest-right">
              <p className="dest-description">
                Ceylon D Tour provides exciting Hikkaduwa beach holiday packages with reliable transportation, snorkeling and diving arrangements, and accommodation assistance. Our services include coral reef tours, surfing lessons, turtle hatchery visits, and beachside relaxation. With Ceylon D Tour, you can enjoy Hikkaduwa's vibrant beach culture, marine adventures, and coastal entertainment with personalized service and flexible travel arrangements tailored to your preferences.
              </p>
            </div>
          </div>

          {/* Destination Suggestions */}
          <DestinationSuggestions 
            currentDestination="Hikkaduwa"
            suggestions={getRandomSuggestions('/places/hikkaduwa', 4)}
          />
        </div> {/* End of dest-container */}
      </section>
      </div>
    </div>
  );
};

export default Hikkaduwa;

